import type { TrialStatusResponse } from "@/app/api/__generated__/models/trialStatusResponse";
import { Button } from "@/components/atoms/Button/Button";
import { Text } from "@/components/atoms/Text/Text";
import { Dialog } from "@/components/molecules/Dialog/Dialog";
import { TrialTimeLeft } from "./components/TrialTimeLeft";
import { WorthDoingPanel } from "./components/WorthDoingPanel";

interface Props {
  trial: TrialStatusResponse;
  isOpen: boolean;
  isResuming: boolean;
  onResume: () => void;
  onSubscribe: () => void;
  onClose: () => void;
}

export function TrialCanceledDialog({
  trial,
  isOpen,
  isResuming,
  onResume,
  onSubscribe,
  onClose,
}: Props) {
  if (!trial.offer) return null;
  return (
    <Dialog
      title="Cancellation confirmed"
      styling={{ maxWidth: "29rem", minWidth: "auto" }}
      controlled={{
        isOpen,
        set: (open) => {
          if (!open) onClose();
        },
      }}
    data-sentry-element="Dialog" data-sentry-component="TrialCanceledDialog" data-sentry-source-file="TrialCanceledDialog.tsx">
      <Dialog.Content data-sentry-element="Dialog.Content" data-sentry-source-file="TrialCanceledDialog.tsx">
        <div
          data-slot="trial-canceled-dialog-body"
          className="flex flex-col gap-4"
        >
          <Text variant="body" tone="emphasis" data-sentry-element="Text" data-sentry-source-file="TrialCanceledDialog.tsx">
            Your card won&apos;t be charged.{" "}
            <TrialTimeLeft endsAt={trial.ends_at} data-sentry-element="TrialTimeLeft" data-sentry-source-file="TrialCanceledDialog.tsx" />
          </Text>
          <WorthDoingPanel offer={trial.offer} endsAt={trial.ends_at} data-sentry-element="WorthDoingPanel" data-sentry-source-file="TrialCanceledDialog.tsx" />
        </div>
        <Dialog.Footer data-sentry-element="Dialog.Footer" data-sentry-source-file="TrialCanceledDialog.tsx">
          <Button
            variant="outline"
            onClick={onResume}
            loading={isResuming}
            disabled={isResuming}
          data-sentry-element="Button" data-sentry-source-file="TrialCanceledDialog.tsx">
            Resume trial
          </Button>
          <Button variant="primary" onClick={onSubscribe} data-sentry-element="Button" data-sentry-source-file="TrialCanceledDialog.tsx">
            Subscribe now
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
}
